var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2999 12.5001L14.8521 3.15358C14.3186 2.56337 14.3415 1.6586 14.904 1.09604V1.09604C15.5026 0.497463 16.4785 0.515529 17.0545 1.13586L27.989 12.9114C28.559 13.5253 28.559 14.475 27.989 15.0889L17.0545 26.8644C16.4785 27.4847 15.5026 27.5028 14.904 26.9042V26.9042C14.3415 26.3417 14.3186 25.4369 14.8521 24.8467L23.2999 15.5001H1.49995C0.671522 15.5001 -5.14984e-05 14.8286 -5.14984e-05 14.0001V14.0001C-5.14984e-05 13.1717 0.671521 12.5001 1.49995 12.5001H23.2999Z",
    fill: "#E22454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.3ed3bedc1864bd2f271b1e73c1e97799.svg";
export { ForwardRef as ReactComponent };